export const chat = {
  extends: 'Page',
  flow: 'y',
  theme: 'document',
  height: '100vh',
  overflow: 'hidden',

  LawyersData: {
    fetch: {
      from: 'lawyers',
      order: { by: 'info_score', asc: false },
      limit: 50,
      cache: '5m',
      keepPreviousData: true,
      transform: (data, el) => {
        const lawyers = (data || []).map(d => el.call('mapLawyer', d))
        const root = el.state.root || el.state
        if (root && root.update) root.update({ lawyers, lawyersLoaded: true }, { preventFetch: true })
        return lawyers
      }
    },
    display: 'none'
  },

  FirmsData: {
    fetch: {
      from: 'law_firms',
      order: { by: 'name_en', asc: true },
      limit: 50,
      cache: '5m',
      keepPreviousData: true,
      transform: (data, el) => {
        const firms = (data || []).map(d => el.call('mapFirm', d))
        const root = el.state.root || el.state
        if (root && root.update) root.update({ firms, firmsLoaded: true }, { preventFetch: true })
        return firms
      }
    },
    display: 'none'
  },

  LandingNav: {},

  ChatLayout: {
    flow: 'y',
    flex: '1',
    overflow: 'hidden',
    paddingTop: 'D',

    WelcomeMsg: {
      show: (el, s) => !(s.root.chatMessages || []).length && !s.root.chatTyping,
      flow: 'y',
      align: 'center center',
      gap: 'A',
      padding: 'D B',
      textAlign: 'center',
      flex: '1',

      WelcomeIcon: { text: '\u2696\uFE0F', fontSize: 'G' },
      WelcomeTitle: { tag: 'h2', text: 'Legal Assistant', fontSize: 'D', fontWeight: '700', letterSpacing: '-0.02em' },
      WelcomeSub: { text: 'Ask about Georgian law, legal procedures, or find a lawyer', fontSize: 'B', opacity: '0.5', maxWidth: 'H' },

      Suggestions: {
        flow: 'x',
        gap: 'Y',
        flexWrap: 'wrap',
        align: 'center center',
        marginTop: 'A',
        children: [
          { label: '\uD83D\uDCDC How to file a civil lawsuit in Georgia?' },
          { label: '\uD83C\uDFE0 Real estate purchase process for foreigners' },
          { label: '\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67 Divorce and child custody laws' },
          { label: '\uD83C\uDFE2 Starting a business in Georgia' }
        ],
        childrenAs: 'state',
        childProps: {
          tag: 'button',
          text: (el, s) => s.label,
          padding: 'Z A', round: 'Z', fontSize: 'A', cursor: 'pointer',
          border: 'none', theme: 'ghost', transition: 'all 0.2s ease',
          ':hover': { theme: 'secondary' },
          onClick: (e, el, s) => {
            const msg = s.label.replace(/^[\uD800-\uDBFF][\uDC00-\uDFFF]\s*/, '')
            el.call('triggerChat', msg)
          }
        }
      }
    },

    ThreadBody: {
      show: (el, s) => (s.root.chatMessages || []).length > 0 || s.root.chatTyping,
      flex: '1',
      flow: 'y',
      gap: 'A',
      padding: 'B C',
      overflow: 'auto',
      maxWidth: '1680px',
      width: '100%',
      margin: '0 auto',
      '@mobileL': { padding: 'A' },

      children: (el, s) => {
        return (s.root.chatMessages || []).map(m => {
          const entry = { role: m.role, content: m.content }
          if (m.role === 'assistant') {
            entry.cleanContent = m.content
            entry.sourceLinks = el.call('parseChatLinks', m.content)
            if (m.recommended) entry.recommended = m.recommended
          }
          return entry
        })
      },
      childrenAs: 'state',
      childProps: {
        flow: 'y',
        gap: 'Z',
        maxWidth: 'J',
        width: '100%',
        margin: '0 auto',

        MsgBubble: {
          padding: 'A B',
          round: 'A',
          background: (el, s) => s.role === 'user' ? 'greenBg' : 'surfaceCard',
          border: (el, s) => s.role === 'user' ? '1px solid greenBorder' : '1px solid surfaceBorderStrong',
          alignSelf: (el, s) => s.role === 'user' ? 'flex-end' : 'flex-start',
          maxWidth: '85%',

          RoleLabel: {
            text: (el, s) => s.role === 'user' ? 'You' : '\u2696\uFE0F Legal Assistant',
            fontSize: 'Z', fontWeight: '600', opacity: '0.6', marginBottom: 'Y'
          },
          MsgText: {
            tag: 'div',
            html: (el, s) => el.call('formatChatHtml', s.role === 'user' ? s.content : (s.cleanContent || s.content)),
            fontSize: 'A', lineHeight: '1.7'
          },

          SourceLinks: {
            show: (el, s) => s.role === 'assistant' && s.sourceLinks && s.sourceLinks.length > 0,
            flow: 'x', gap: 'Y', flexWrap: 'wrap',
            marginTop: 'Y', padding: 'Y 0 0 0', borderTop: '1px solid surfaceBorderStrong',
            children: (el, s) => {
              const seen = new Set()
              return (s.sourceLinks || []).filter(l => { if (seen.has(l.url)) return false; seen.add(l.url); return true })
            },
            childrenAs: 'state',
            childExtends: 'Link',
            childProps: {
              href: (el, s) => s.url || '#', attr: { target: '_blank' },
              text: (el, s) => '\uD83D\uDD17 ' + (s.label || ''),
              fontSize: 'Z', color: 'green', textDecoration: 'none',
              padding: 'Y Z', round: 'W', background: 'greenBg',
              ':hover': { textDecoration: 'underline' }
            }
          }
        },

        QuickActions: {
          show: (el, s) => s.role === 'assistant' && !s.recommended,
          flow: 'x',
          gap: 'Y',
          flexWrap: 'wrap',
          marginTop: 'Y',
          children: [
            { label: '\uD83D\uDC68\u200D\u2696\uFE0F Find a lawyer', action: 'find_lawyer' },
            { label: '\uD83D\uDCDE Book consultation', action: 'book' },
            { label: '\u2753 Ask another question', action: 'ask' }
          ],
          childrenAs: 'state',
          childProps: {
            tag: 'button',
            text: (el, s) => s.label,
            padding: 'Z A', round: 'Z', fontSize: 'Z',
            cursor: 'pointer', border: 'none', theme: 'ghost',
            transition: 'all 0.2s ease',
            ':hover': { theme: 'secondary' },
            onClick: (e, el, s) => {
              if (s.action === 'find_lawyer') {
                el.call('triggerChat', 'Find me a lawyer for this')
              } else if (s.action === 'book') {
                window.location.href = '/bookings/public'
              } else {
                const input = el.lookup('ChatInput')
                if (input && input.node) input.node.focus()
              }
            }
          }
        },

        RecommendedCards: {
          show: (el, s) => s.role === 'assistant' && s.recommended && s.recommended.length > 0,
          flow: 'y', gap: 'Y', width: '100%',
          children: (el, s) => s.recommended || [],
          childrenAs: 'state',
          childExtends: 'Link',
          childProps: {
            href: (el, s) => s.id ? ((s._cardType === 'firm' ? '/firm' : '/lawyer') + '?slug=' + (s.slug || s.id)) : '#',
            textDecoration: 'none', color: 'inherit',
            flow: 'x', gap: 'Z', align: 'center flex-start',
            padding: 'Z A', round: 'Z', theme: 'card',
            border: '1px solid greenBorder', cursor: 'pointer',
            transition: 'all 0.2s ease',
            ':hover': { boxShadow: 'black.1 0 Y Z' },

            CardAvatar: {
              tag: 'img', width: 'B1', height: 'B1',
              round: (el, s) => s._cardType === 'firm' ? 'Y' : 'B1',
              objectFit: 'cover', flexShrink: '0',
              attr: { src: (el, s) => s.photoUrl || s.avatar || s.logo || 'https://ui-avatars.com/api/?name=' + encodeURIComponent(s.nameEn || '') + '&background=1a2332&color=c6ac8f&size=64&bold=true&format=svg' }
            },
            CardInfo: {
              flow: 'y', gap: 'V', flex: '1', minWidth: '0',
              CardName: { text: (el, s) => s.nameEn || '', fontSize: 'A', fontWeight: '600' },
              CardMeta: {
                flow: 'x', gap: 'Y', align: 'center flex-start',
                CardCity: { text: (el, s) => s.city || '', fontSize: 'Z', opacity: '0.6' },
                CardDot: { text: '\u00B7', fontSize: 'Z', opacity: '0.4' },
                CardSpec: {
                  text: (el, s) => s._cardType === 'firm' ? 'Law Firm' : (s.specializations || []).slice(0, 2).join(', '),
                  fontSize: 'Z', opacity: '0.6'
                }
              },
              CardBadge: {
                show: (el, s) => s.isSubscribed || s._cardType === 'firm',
                text: (el, s) => s._cardType === 'firm' ? '\uD83C\uDFE2 Law Firm' : '\u2605 Verified',
                fontSize: 'Y', fontWeight: '700', color: 'green', textTransform: 'uppercase', letterSpacing: '0.05em'
              }
            },
            CardRating: {
              show: (el, s) => s._cardType !== 'firm' && s.rating > 0,
              flow: 'x', gap: 'W', align: 'center center', flexShrink: '0',
              RatingStar: { text: '\u2605', fontSize: 'A', color: 'green' },
              RatingVal: { text: (el, s) => String(s.rating), fontSize: 'A', fontWeight: '600', color: 'green' }
            }
          }
        }
      }
    },

    LoadingIndicator: {
      show: (el, s) => s.root.chatTyping,
      padding: '0 C', maxWidth: 'J', width: '100%', margin: '0 auto',
      '@mobileL': { padding: '0 A' },
      TypingBubble: {
        padding: 'Z A', round: 'A', background: 'surfaceCard',
        border: '1px solid surfaceBorderStrong', alignSelf: 'flex-start',
        text: '\u2696\uFE0F Thinking...', fontSize: 'A', opacity: '0.6'
      }
    },

    InputArea: {
      position: 'relative',
      padding: 'A C',
      borderTop: '1px solid surfaceBorderStrong',
      flexShrink: '0',
      maxWidth: '1680px',
      width: '100%',
      margin: '0 auto',
      '@mobileL': { padding: 'A' },

      ChatInput: {
        tag: 'textarea', placeholder: 'Ask about Georgian law...',
        width: '100%', padding: 'A', round: 'A', theme: 'card',
        fontSize: 'A', fontFamily: 'inherit', outline: 'none',
        resize: 'none', height: 'D1', lineHeight: '1.5',
        attr: { rows: '4' },
        onKeyDown: (e, el, s) => {
          if (e.key === 'Enter' && !e.shiftKey && !e.altKey) {
            e.preventDefault()
            const query = el.node.value
            if (!query.trim() || s.root.chatTyping) return
            el.node.value = ''
            el.call('triggerChat', query)
          }
        }
      },

      SendBtn: {
        tag: 'button',
        position: 'absolute',
        top: 'A1',
        right: 'C1',
        width: 'C',
        height: 'C',
        background: 'white',
        color: 'neutral950',
        border: 'none',
        round: '100%',
        cursor: 'pointer',
        align: 'center center',
        transition: 'all 0.2s ease',
        boxShadow: 'black.08 0 V Y',
        ':hover': { background: 'green', color: 'neutral950' },
        text: '\u2303',
        '@mobileL': { right: 'A1' },
        onClick: (e, el, s) => {
          const input = el.lookup('ChatInput')
          const query = input && input.node ? input.node.value : ''
          if (!query.trim() || s.root.chatTyping) return
          input.node.value = ''
          el.call('triggerChat', query)
        }
      }
    }
  }
}
